import { passCodes } from '../passCodes';
import cipher20Hint2 from '../../../../assets/images/games/zdar-escape-game/ciphers/20/hint2-transparent.webp';
import track20 from '../../../../assets/audio/tracks/track20.mp3';

const hints = [
    {
        text: 'První a poslední, to je ten princip.',
    },
    {
        image: cipher20Hint2,
    },
    {
        text: 'Kódem je: náměstí',
        solution: true,
    },
];
export const step20crossroads = {
    id: 19,
    title: '8. stanoviště',
    taskText: `
        <p>
            A hele, co to tu zase máme. Šifra! Hodně štěstí! 
        </p>
    `,
    catImage: 2,
    audio: track20,
    snowAudio: track20,
    cipher: {
        label: 'Úkol',
        text: `
            <p>Jak zní poslední slovo šifry?</p>
            <div class="middle">
                <b>jeetd/serm/zard/nmsitea</b>                    
            </div>
        `,
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[13],
    additionalInfo: 'Odpovědí je jedno slovo.',
    hints: hints,
    snowHints: hints,
};
